import { Flex } from '@chakra-ui/react';
import React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { textLayoutAtom, windowSizeAtom } from '../../recoil/atom/counter';
import { onlyKoreanCharCountSelector } from '../../recoil/selector/counter';

const ContentBox: React.FC = () => {
  const [windowSizeState] = useRecoilState(windowSizeAtom);
  const [textLayoutState] = useRecoilState(textLayoutAtom);
  const koreanChars = useRecoilValue(onlyKoreanCharCountSelector);

  return (
    <Flex
      direction="row"
      style={{
        visibility: koreanChars > 20 ? 'visible' : 'hidden',
        width: `${windowSizeState.width}px`,
        height: `${windowSizeState.height}px`,
        paddingLeft: `${textLayoutState.character.margin.left}px`,
        paddingRight: `${textLayoutState.character.margin.right}px`,
      }}
    >
      {textLayoutState.character.widths.map((width, ii) => {
        return (
          <div
            key={`col-${ii}`}
            style={{ width: `${width.width}px`, marginRight: `${width.margin}px`, height: `${windowSizeState.height}px}` }}
          >
            {textLayoutState.character.heights[ii].map((height, jj) => {
              return (
                <div key={`row-${ii}-${jj}`} style={{ width: `${width.width}px`, height: `${height.height}px` }}>
                  <p
                    style={{
                      margin: 0,
                      padding: 0,
                      lineHeight: 1,
                      fontSize: `${width.width}px`,
                      transform: `scaleY(${height.scale / 100})`,
                    }}
                  >
                    {textLayoutState.letters[ii][jj]}
                  </p>
                </div>
              );
            })}
          </div>
        );
      })}
    </Flex>
  );
};

export default ContentBox;
